import { axiosInstance } from "./BaseService" 

export async function createFile(file) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post('/files', formData);
    return response.data;
  } catch (err) {
    console.error("Erro no serviço de arquivos:", err);
    return {
      success: false,
      message: err.message,
    };
  }
}

export async function saveFile(newFile) {
  const response = await axiosInstance.patch('/files', { files: [newFile] });
  return response.data;
}